import { Fetch } from 'lib';
import type { ProductPriceType, ProductStatus } from 'types';

type RequestResponses = {};

type RequestParameters = {
  categoriesIds?: string[];
  brandsIds?: string[];
  statuses?: ProductStatus[];
  lowerBoundCreateDate?: string;
  upperBoundCreateDate?: string;
  amount: number;
  type: ProductPriceType;
};

const bulkUpdateProducts = async ({
  categoriesIds,
  brandsIds,
  statuses,
  lowerBoundCreateDate,
  upperBoundCreateDate,
  amount,
  type,
}: RequestParameters) => {
  const params: Record<string, unknown> = {
    amount,
    type,
  };

  if (categoriesIds) {
    params['categoriesIds'] = categoriesIds;
  }
  if (brandsIds) {
    params['brandsIds'] = brandsIds;
  }
  if (statuses) {
    params['statuses'] = statuses;
  }
  if (lowerBoundCreateDate) {
    params['lowerBoundCreateDate'] = lowerBoundCreateDate;
  }
  if (upperBoundCreateDate) {
    params['upperBoundCreateDate'] = upperBoundCreateDate;
  }

  return await Fetch<RequestResponses, typeof params>({
    url: 'adminProduct/bulkUpdateProducts',
    method: 'POST',
    params,
  });
};

export { bulkUpdateProducts };
